export default "__VITE_ASSET__C8rwvnGU__"